import _ from 'lodash';
import { languageToSourceMap } from '~/constants/ModelConstants';

const ArtifactHelper = function() {
  const buildEditedArtifact = function(artifact, edits) {
    const editedArtifact = _.cloneDeep(artifact),
      artifactEdits = edits,
      summaryEdits = artifactEdits.SUMMARY;

    if (summaryEdits) {
      if (summaryEdits.title) {
        editedArtifact.title = summaryEdits.title;
      }
      if (summaryEdits.vulnerabilityTypes) {
        editedArtifact.vulnerabilityTypes = summaryEdits.vulnerabilityTypes;
      }
      if (summaryEdits.cveYear) {
        editedArtifact.cveYear = summaryEdits.cveYear;
      }
      if (summaryEdits.cveDigits) {
        editedArtifact.cveDigits = summaryEdits.cveDigits;
      }
      if (summaryEdits.stage) {
        editedArtifact.stage = summaryEdits.stage;
      }
      if (summaryEdits.language) {
        editedArtifact.language = summaryEdits.language;
      }
      if (summaryEdits.cveStatus) {
        editedArtifact.cveStatus = summaryEdits.cveStatus;
      }
    }

    if (artifactEdits.REFERENCES && artifactEdits.REFERENCES.artifactLinks) {
      editedArtifact.artifactLinks = artifactEdits.REFERENCES.artifactLinks;
    }

    if (artifactEdits.TECHNICAL && artifactEdits.TECHNICAL.overview) {
      editedArtifact.overview = artifactEdits.TECHNICAL.overview;
    }

    if (artifactEdits.TECHNICAL && artifactEdits.TECHNICAL.teardown) {
      editedArtifact.teardown = artifactEdits.TECHNICAL.teardown;
    }

    if (artifactEdits.RISK) {
      editedArtifact.nvdCvssVector = artifactEdits.RISK.nvdCvssVector;
      editedArtifact.srcclrCvssVector = artifactEdits.RISK.srcclrCvssVector;
      editedArtifact.srcclrCvssScore = artifactEdits.RISK.srcclrCvssScore;
      editedArtifact.nvdCvssScore = artifactEdits.RISK.nvdCvssScore;
    }

    if (artifactEdits.FIX) {
      editedArtifact.artifactComponents = artifactEdits.FIX.artifactComponents;
    }

    return editedArtifact;
  };

  const calculateRiskLevel = function(score) {
    if (score >= 7) {
      return 'high';
    } else if (score >= 4) {
      return 'medium';
    } else {
      return 'low';
    }
  };

  const isArtifactPremium = function(artifact) {
    const cveStatus = artifact && artifact.cveStatus && artifact.cveStatus.toUpperCase();
    return cveStatus !== 'FINAL';
  };

  const getLanguageByCoordType = coordinateType => {
    const coordType = coordinateType.toLowerCase();
    return Object.keys(languageToSourceMap).find(key => {
      const coordTypes = languageToSourceMap[key].map(type => type.toLowerCase());
      return coordTypes.includes(coordType);
    });
  };

  return {
    buildEditedArtifact,
    calculateRiskLevel,
    isArtifactPremium,
    getLanguageByCoordType,
  };
};

export default new ArtifactHelper();
